<div class="card mb-5" [style.height]="data.chartConfig?.height || 'auto'">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column align-items-center">
      <h4 style="margin: 0; font-weight: bold;" [style.font-size]="data.chartConfig?.titleFontSize || '2.05rem'">{{
        data.title }}</h4>
    </div>
  </div>
  <div class="card-body" style="height: 100%; padding-bottom: 2rem;">
    <ng-container *ngIf="!hasError; else errorBlock">
      <div class="chart-scale-wrap"
        [style.transform]="data.chartConfig?.wrapperScale ? 'scale(' + data.chartConfig.wrapperScale + ')' : null"
        [style.transformOrigin]="data.chartConfig?.wrapperScale ? 'top left' : null"
        [style.width]="data.chartConfig?.wrapperScale ? (100 / data.chartConfig.wrapperScale) + '%' : null">
        <div class="row h-100 g-0">
          <!-- Left Column: Horizontal Bar Chart -->
          <div [ngClass]="[data.showStack ? 'col-10' : 'col-12', 'h-100']">
            <div [id]="data.widgetId" class="chart-container"></div>
          </div>

          <!-- Right Column: Vertical Percentage Boxes (only if showStack is true) -->
          <div *ngIf="data.showStack" class="col-2 h-100">
            <div class="percentage-boxes-wrapper" [class.pixel-aligned]="hasPixelBoxPositions"
              [style.--box-grid-top]="data.chartConfig?.gridTop || '10%'"
              [style.--box-grid-bottom]="data.chartConfig?.gridBottom || '10%'">
              <div *ngFor="let item of displayData" class="percentage-box-container highlighted"
                [style.top.px]="hasPixelBoxPositions ? getPercentageBoxTop(item.category) : null">
                <div class="percentage-box" *ngIf="item.showBox">
                  <span class="percentage-label">{{ item.category }}</span>
                  <span class="percentage-value">{{ item.percentage }}</span>
                </div>
              </div>
              
              <!-- Note box for Catastrophic Failure - added as part of the stack -->
              <div *ngIf="noteBoxStyle && noteBoxStyle.visible" 
                style="position: absolute; bottom: 2px; left: 15px; right: 5px; padding: 30px -35px; background-color: #fff8f8; border: 4px solid #d46a6a; border-radius: 4px; font-weight: bold; font-size: 15px; color: #d46a6a; text-align: center; z-index: 10; box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); line-height: 1.3;">
                2025 data is being used for scoring
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #errorBlock>
      <app-data-error [message]="errorMessage" />
    </ng-template>
  </div>
</div>
